// src/admin/pages/Auth/authFetch.js
const originalFetch = window.fetch.bind(window);

function goLogin(msg) {
  console.warn("[authFetch] redirect ->", msg);
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  // Attendi la fine dello stack per evitare conflitti con React
  setTimeout(() => window.location.replace("/"), 0);
}

export async function authFetch(url, options = {}) {
  console.log("[authFetch] CALL:", url);          // <‑‑ DEBUG
  const token = localStorage.getItem("access_token");
  const headers = { ...(options?.headers || {}) };
  if (token) headers.Authorization = `Bearer ${token}`;

  try {
    const res = await originalFetch(url, { ...options, headers });
    console.log("[authFetch] STATUS:", res.status); // <‑‑ DEBUG

    if (res.status === 401 || res.status === 403) {
      goLogin(res.status);
      throw new Error("UNAUTHENTICATED");
    }
    return res;
  } catch (err) {
    // Anche fetch network‑error (es. CORS) forza login
    console.error("[authFetch] ERROR:", err);
    goLogin(err.message);
    throw err;
  }
}
